import { render, staticRenderFns } from "./PageRegNotes.vue?vue&type=template&id=0d64f0c6&scoped=true"
import script from "./PageRegNotes.vue?vue&type=script&lang=js"
export * from "./PageRegNotes.vue?vue&type=script&lang=js"
import style0 from "./PageRegNotes.vue?vue&type=style&index=0&id=0d64f0c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d64f0c6",
  null
  
)

export default component.exports